import styled from "@emotion/styled";
import { LinearProgress, Stack } from "@mui/material";
import { useMemo } from "react";

const Container = styled.div`
  padding: 16px 32px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.neutral.main};
  color: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid transparent;
  flex: 3;
`;

const Stat = styled.div`
  font-weight: 900;
  font-size: 24px;
  color: #687588;
`;

const ProgressLabel = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
`;

const ProgressContainer = styled.div`
  position: relative;
`;

const ProgressPercentage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-size: 12px;
  font-weight: 600;
`;

export const GoalCard = ({ pledged, raised, target = 100 }) => {
  const progress = useMemo(() => {
    return (raised / target) * 100;
  }, [raised, target]);

  const normalizedProgress = useMemo(() => {
    return Math.min(Math.max(progress, 0), 100);
  }, [progress]);

  return (
    <Container>
      <Stack direction="row" justifyContent="center" spacing={1}>
        <Stat>
          {Number(pledged).toLocaleString()} Pledged /{" "}
          {Number(raised).toLocaleString()} Raised
        </Stat>
      </Stack>
      <ProgressContainer>
        <LinearProgress
          variant="determinate"
          value={normalizedProgress}
          sx={{ height: 24, borderRadius: 12 }}
        />
        <ProgressPercentage>
          {normalizedProgress.toFixed(0)}%
        </ProgressPercentage>
      </ProgressContainer>
      <ProgressLabel>
        <span>{Number(raised).toLocaleString()} ETB</span>
        <span>{Number(target).toLocaleString()} ETB</span>
      </ProgressLabel>
    </Container>
  );
};
